import styled from "styled-components";
import { H4, Layout, Card, Stack, Title, Button, useToast } from "@introist/react-foundation/v2";
import { AutomationAutoRemovalConfig } from "../WorkspaceSettingsRoute/components/AutomationAutoRemovalConfig";
import { EmployeeDataRemovalConfig } from "./components/EmployeeDataRemovalConfig";
import { apiClient } from "services/rpc/RpcProvider";

const StyledDataRetentionRoute = styled(Layout.Group)`
  flex: 1;
  user-select: none;
`;

export const DataRetentionRoute = () => {
  const toast = useToast();

  const handleDownloadPolicy = async () => {
    try {
      const response = await apiClient.employees.v4.deletion.policy.downloadPolicy.mutate();

      // Decode base64 data
      const byteCharacters = atob(response.data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: response.contentType });

      // Create object URL
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link to open in new tab with download attribute
      const link = document.createElement("a");
      link.href = url;
      link.download = response.filename;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the URL after a short delay
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.log(error);
      toast.error("Failed to open policy");
    }
  };

  return (
    <StyledDataRetentionRoute vertical gap="xxLarge">
      <Card>
        <Stack vertical gap="medium">
          <H4>Data Retention</H4>
          <Title>Configure data retention policies for your workspace.</Title>
        </Stack>
      </Card>

      <Card>
        <Stack vertical>
          <H4>Employee data removal</H4>

          <Stack vertical style={{ display: "grid", gridTemplateColumns: "400px 1fr" }}>
            <Title style={{ marginTop: "var(--spacing-medium)" }}>
              Automatically remove employees
            </Title>
            <div>
              <EmployeeDataRemovalConfig />
            </div>
          </Stack>
        </Stack>
      </Card>

      <Card>
        <Stack
          vertical
          style={{
            display: "grid",
            gridTemplateColumns: "400px 1fr",
            alignItems: "center"
          }}
        >
          <H4 style={{ marginBottom: "var(--spacing-medium)" }}>Automation data removal</H4>
          <div />

          <Title>Automatically remove completed automations.</Title>
          <div>
            <AutomationAutoRemovalConfig />
          </div>
        </Stack>
      </Card>

      <Card>
        <Stack
          vertical
          style={{
            display: "grid",
            gridTemplateColumns: "400px 1fr",
            alignItems: "center"
          }}
        >
          <H4 style={{ marginBottom: "var(--spacing-medium)" }}>Data Retention Policy</H4>
          <div />

          <Title>Download your workspace data retention policy document</Title>
          <div>
            <Button variant="outlined" onClickWithLoading={handleDownloadPolicy}>
              Download Policy
            </Button>
          </div>
        </Stack>
      </Card>
    </StyledDataRetentionRoute>
  );
};
